<template>
  <div class="graphics">
    <canvas class="canvas" id="dotacion"></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

export default {
  name: "PlanetChart",
  data() {
    return {
      img: "",
      graphicLabels: null,
      graphicData: null,
      myChart: null,
    };
  },
  props: ["labels", "data", "highestValue"],
  watch: {
    labels: function() {
      this.graphicLabels = this.$props.labels;
    },
    data: function() {
      this.graphicData = this.$props.data;
      this.grafica();
    },
  },
  methods: {
    grafica: function() {
      var ctx = document.getElementById("dotacion").getContext("2d");
      if (this.myChart) {
        this.myChart.destroy();
      }
      const footer = (tooltipItems) => {
        var sum = 0;

        tooltipItems.forEach((tooltipItem) => {
          sum = `Hombres: ${this.graphicData.perc.h[tooltipItem.parsed.x]}%\nMujeres: ${this.graphicData.perc.m[tooltipItem.parsed.x]}%`;
        });
        return sum;
      };
      this.myChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.graphicLabels,
          datasets: [
            {
              label: "Mujeres",
              data: this.data.m,
              backgroundColor: ["#2ecc71"],
              borderColor: ["#2ecc71"],
              barThickness: 40,
            },
            {
              label: "Hombres",
              data: this.graphicData.h,
              backgroundColor: ["#770baa"],
              borderColor: ["#770baa"],
              barThickness: 40,
            },
          ],
        },
        options: {
          scales: {
            x: {
              title: {
                display: true,
                text: "Estamento",
                font: {
                  weight: "bold",
                },
              },
              grid: {
                display: false
              }
            },
            y: {
              max: this.highestValue,
              title: {
                display: true,
                text: "Personas",
                font: {
                  weight: "bold",
                },
              }
            },
          },
          plugins: {
            legend: {
              display: true,
              position: "bottom",
            },
            tooltip: {
              callbacks: {
                footer: footer,
              },
            },
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.canvas {
  font-size: 14px;
  color: #052333;
}
.graphics {
  padding-bottom: 2rem;
  padding: 1rem 5rem;
}
</style>
